var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-bg-gray-100"},[_c('Header'),_c('div',{staticClass:"c-container h-full"},[_c('div',{staticClass:"c-row c-horizontal-center h-full"},[_c('div',{staticClass:"c-col-2 sm:c-col-6 md:c-col-10 lg:c-col-8"},[_c('div',{staticClass:"ui-my-8"},[_c('router-view')],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }